import {Brands, Buy, CTA, Footer, Header,Hero, StartDoc, Testimonials, Youneed} from './components/components.js';


function App() {
  return (
    <>
      <Header />
      <Hero />
      <Brands />
      <StartDoc />
      <Youneed />
      <Buy />
      <Testimonials />
      <CTA />
      <Footer />
    </>
  );
}

export default App;
